import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Psychologist } from '../../../shared/models/psychologist.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const DEFAULT_FILTERS = {
  age_lower: null,
  age_upper: null,
  doc_ref: null,
  limit: 10,
  fullName: null,
  page: 0,
  phone: null,
  email: null,
  // specialties: null,
};

@Injectable({
  providedIn: 'root',
})
export class PsychologistService {
  baseURL = `${environment.baseURL}/psychologists`;
  PsychologistList = new BehaviorSubject<any[]>([]);

  constructor(private http: HttpClient) {}

  getPsychologist(
    filters: any,
    limit: number = 10
  ): Observable<Psychologist[]> {
    const filterBody = this.getPsychologistFilters(filters, limit);

    this.http
      .post<Psychologist[]>(this.baseURL + '/find', filterBody)
      .subscribe((data) => {
        this.PsychologistList.next(data);
      });

    return this.PsychologistList;
  }

  findPsychologists(filters: any, limit: number = 10): Observable<Psychologist[]> {
    const filterBody = this.getPsychologistFilters(filters, limit);
    return this.http.post<Psychologist[]>(this.baseURL + '/find', filterBody);
  }

  getSinglePsychologist(id: string) {
    const filters = {
      ...DEFAULT_FILTERS,
      doc_ref: id,
      limit: 1,
    };

    return this.http.post<Psychologist[]>(this.baseURL + '/find', filters);
  }

  createPsychologist(requestData: Psychologist) {
    return this.http.post(this.baseURL + '/import', requestData);
  }

  fromAvailObjectToString(object: any, type: string) {
    let result = '';
    if (object) {
      switch (type) {
        case 'hours':
          result += object['mor'] ? 'mor' : '';
          result += object['aft'] ? (result !== '' ? '-aft' : 'aft') : '';
          result += object['eve'] ? (result !== '' ? '-eve' : 'eve') : '';
          return result;
        case 'days':
          result += object['sun'] ? 'sun' : '';
          result += object['mon'] ? (result !== '' ? '-mon' : 'mon') : '';
          result += object['tue'] ? (result !== '' ? '-tue' : 'tue') : '';
          result += object['wed'] ? (result !== '' ? '-wed' : 'wed') : '';
          result += object['thu'] ? (result !== '' ? '-thu' : 'thu') : '';
          result += object['fri'] ? (result !== '' ? '-fri' : 'fri') : '';
          result += object['sat'] ? (result !== '' ? '-sat' : 'sat') : '';
          return result;
        case 'contract':
          result += object['occ'] ? 'occ' : '';
          result += object['part'] ? (result !== '' ? '-part' : 'part') : '';
          result += object['full'] ? (result !== '' ? '-full' : 'full') : '';
          return result;
        case 'tasks1':
        case 'tasks2':
          result += object['assistance'] ? 'assistance' : '';
          result += object['care'] ? (result !== '' ? '-care' : 'care') : '';
          result += object['drugs'] ? (result !== '' ? '-drugs' : 'drugs') : '';
          result += object['cooking']
            ? result !== ''
              ? '-cooking'
              : 'cooking'
            : '';
          result += object['housing']
            ? result !== ''
              ? '-housing'
              : 'housing'
            : '';
          result += object['other'] ? (result !== '' ? '-other' : 'other') : '';
          return result;
        default:
          return '';
      }
    } else {
      return result;
    }
  }

  updatePsychologist(requestData: Psychologist) {
    return this.http.post(this.baseURL + '/import', requestData);
  }

  private getPsychologistFilters(filters: any, limit: number) {
    if (filters) {
      return {
        age_lower: filters.age_lower ?? null,
        age_upper: filters.age_upper ?? null,
        doc_ref: filters.doc_ref ?? null,
        limit: limit,
        fullName: filters.name ?? null,
        name: filters.name ?? null,
        page: filters.page ?? 0,
        phone: filters.phone ?? null,
        email: filters.email ?? null,
        specialties: filters.specialties ?? null,
      };
    }
    return DEFAULT_FILTERS;
  }

  deletePsychologist(doc_ref: string) {
    return this.http.delete(this.baseURL + '/delete/' + doc_ref);
  }
}
